import { createSlice } from "@reduxjs/toolkit";
import { AllProductsAPI } from "../../actions/adminActions/allProductsAction";

const initialState = {
  all_products: [],
};

const AllProductsSlice = createSlice({
  name: "allproducts",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(AllProductsAPI.fulfilled, (state, { payload }) => {
      console.log("All Products fetched are:", payload);
      state.all_products_slice = payload?.data?.data;
    });
    builder.addCase(AllProductsAPI.rejected, (state, action) => {
      console.error("Fetch All Products failed:", action.error.message);
    });
  },
});

export default AllProductsSlice.reducer;
